import React, { useState } from 'react';
import './GroupBookingPredictionLegend.scss';

const GroupBookingPredictionLegend = () => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="occupancy-prediction shadow-lg">
      <button className="close-button" onClick={handleClose}>
        &times; 
      </button>
      <div className="occupancy-label">Occupancy Prediction</div>
      <div className="progress-bar-legend">
        <div className="progress-bar-gradient"></div>
      </div>
      <div className="legend-labels">
        <span>0%</span>
        <span>100%</span>
      </div>
    </div>
  );
};

export default GroupBookingPredictionLegend;
